export default __webpack_public_path__ + "static/media/vitra_chair_11.5c160731.jpg";